import React from 'react'
import IndexLogin from '../Components/Login/IndexLogin'

const Login = () => {
  return (
    <div>
      <IndexLogin/>
    </div>
  )
}

export default Login
